import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Residential from "../pages/residential/page";
import Commercial from "../pages/commercial/page";
import Applications from "../pages/applications/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/residential",
    element: <Residential />,
  },
  {
    path: "/commercial",
    element: <Commercial />,
  },
  {
    path: "/applications",
    element: <Applications />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;